import React, { Component } from 'react' 
//import { translate } from 'react-i18next'
//import * as scale from 'd3-scale'
//import * as shape from 'd3-shape'
//import * as d3Array from 'd3-array' 
import {Button, Icon, Dimmer, Loader } from 'semantic-ui-react'
import { select } from 'd3-selection'
import './LadderChart.css'

class LadderChart extends Component {
  topMargin = 50;
  bottomMargin = 50;
  padLeft = 100;
  padRight = 100;
  ySpacing = 50;
  

  constructor(props) {
    super(props);
    this.state = {
      dataBoxText: "",
      dataBoxIdx: -1
    }
    this.createChart = this.createChart.bind(this);
  }

  componentDidMount() {
    this.createChart();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.createChart();
    }
  }

  getJsMonth(m) {
    switch(m) {
      case 0: return "Jan";
      case 1: return "Feb";
      case 2: return "Mar";
      case 3: return "Apr";
      case 4: return "May";
      case 5: return "Jun";
      case 6: return "Jul";
      case 7: return "Aug";
      case 8: return "Sep";
      case 9: return "Oct ";
      case 10: return "Nov";
      case 11: return "Dec";
      default: return "XXX";
    }
  }

  createChart() {
    // TODO need to handle replace
    const chartRef = select(this.chartRef);
    var reactSelf = this;
    const highlightColor = "#00f";
    const nonHighlightColor = "#000";
    let padLeft = this.padLeft;
    let padRight = this.padRight;
    // there is probably a nice way to do this with selects, but going procedural for now
    //    let g = chartRef.append('g');
    // gather IPs
    let nodeKeys = {};
    let nodes = [];
    this.props.data.forEach(datum => {
      if (!nodeKeys.hasOwnProperty(datum.src_ip)) {
        nodeKeys[datum.src_ip] = nodes.push(datum.src_ip)-1;
      }
      if (!nodeKeys.hasOwnProperty(datum.dst_ip)) {
        nodeKeys[datum.dst_ip] = nodes.push(datum.dst_ip)-1;
      }
    });
    
    if (nodes.length === 0) {
      return;
    }
    let topMargin = this.topMargin;
    let xSpacing = (this.props.width - padLeft - padRight)/(nodes.length-1);
    let ySpacing = this.ySpacing;
    let yBottom = this.props.data.length*this.ySpacing + this.topMargin + this.bottomMargin;
    nodes.forEach((node,ii) => {
      let xPoint = padLeft + xSpacing*ii;
      // add the vertical node lines
      chartRef.append("line")
          .style("stroke", "#333")
          .attr("x1",xPoint)
          .attr("x2",xPoint)
          .attr("y1",topMargin)
          .attr("y2",yBottom);
      // add the node "boxes" for the labels
      // guaranteed to get messy with ipv6 ... TODO fix that
      chartRef.append("g")
          .attr("transform", "translate(" + xPoint + "," + topMargin + ")")
          .attr("class", "class-rect")
          .append("rect")
          .attr("x","-5em")
          .attr("y","-2em")
          .attr("width","10em")
          .attr("height","2em")
      // add the node labels
      chartRef.append("g")
          .attr("transform", "translate(" + xPoint + "," + topMargin + ")")
          .append("text")
          .attr("class", "class-label")
          .attr("text-anchor", "middle")
          .text(function(d) { return node })
          .attr("dy","-.66em")
    });
    this.props.data.forEach((datum,idx) => {
      let x1 = padLeft + nodeKeys[datum.src_ip]*xSpacing;
      let x2 = padLeft + nodeKeys[datum.dst_ip]*xSpacing;
      let y = (idx+1)*ySpacing + topMargin;
      let centerLoc = x2 + (x1<x2 ? -xSpacing/2 : xSpacing/2);
      // add a hitbox
      chartRef.append("g")
          .attr("transform","translate(" + centerLoc + "," + y + ")")
          .style("stroke","#fff")
          .style("fill","#fff")
          .append("rect")
          .attr("x",-xSpacing/2+5)
          .attr("y","-2em")
          .attr("width",xSpacing-10)
          .attr("height","2.2em")
          .on("click", function() {
            let myIdx = reactSelf.state.dataBoxIdx;
            if (myIdx >= 0) {
              chartRef.selectAll(".datum" + myIdx)
                .style("fill", nonHighlightColor);
            }
            reactSelf.setState({dataBoxText:datum.body,dataBoxIdx:idx});
            chartRef.selectAll(".datum"+idx)
              .style("fill", highlightColor);
          })
          .append("svg:title")
          .text(function(d) { return datum.body });
      // add the message lines and direction
      chartRef.append("line")
          .style("stroke", "#000")
          .attr("x1",x1)
          .attr("x2",x2)
          .attr("y1",y)
          .attr("y2",y)
          .attr("marker-end","url(#end)");
      // add the message timestamps
      chartRef.append("g")
          .attr("transform", "translate(" + 0 + "," + y + ")")
          .attr("class", "first")
          .attr("text-anchor", "begin")
          .append("text")
          .style("font-size", "0.8em")
          .attr("class","datum"+idx)
          .text(function(d) {
            let date = new Date(datum.mssep);
            let s = "";
            s = date.getUTCHours() + ":" + date.getUTCMinutes() + ":" + 
              date.getUTCSeconds() + "." + date.getMilliseconds() + "Z";
            return s;
          })
          .append("svg:title")
          .text(function(d) { return datum.body });
      // message labels
      chartRef.append("g")
          .attr("transform", "translate(" + centerLoc + "," + y + ")")
          .append("text")
          .attr("dy","-0.5em")
          .attr("text-anchor","middle")
          .attr("class","datum"+idx)
          .text(function (d) { return datum.msgType })
          .on("click", function(d) {
            let myIdx = reactSelf.state.dataBoxIdx;
            if (myIdx >= 0) {
              chartRef.selectAll(".datum" + myIdx)
                .style("fill", nonHighlightColor);
            }
            reactSelf.setState({dataBoxText:datum.body,dataBoxIdx:idx});
            chartRef.selectAll(".datum"+idx)
              .style("fill", highlightColor);
          })
          .append("svg:title")
          .text(function(d) { return datum.body });
    });

    // add the message arrows ... done here to use "end" on the final side of the line
    chartRef.append("svg:defs").selectAll("marker")
          .data(["end"])      
          .enter().append("svg:marker")
            .attr("id", String)
            .attr("viewBox", "0 -5 10 10")
            .attr("refX", 10)
            .attr("refY", 0)
            .attr("markerWidth", 10)
            .attr("markerHeight", 10)
            .attr("orient", "auto")
            .append("svg:path")
            .attr("d", "M0,-5L10,0L0,5");
  }

  render() {
    const chartRef = select(this.chartRef); 
    return (
      <div>
        {this.state.dataBoxIdx >= 0 &&
          <div className="data-box">
            <div>
              <Button icon
                onClick={() => {
                  let myIdx = this.state.dataBoxIdx;                                   
                  if (myIdx >= 0) {                                                         
                    chartRef.selectAll(".datum" + myIdx)                                    
                      .style("fill", this.nonHighlightColor);                                    
                  }        
                  this.setState({
                    dataBoxIdx: -1,
                    dataBoxText: ""
                  })
                }}
              >
                <Icon className='polycom arrow close' color="red"/>
              </Button> <b>Message Content</b>
            </div>

            {this.state.dataBoxText}
          </div>
        }
        <svg 
          ref={chartRef => this.chartRef = chartRef}
          width={this.props.width}
          height={this.props.data.length*this.ySpacing + this.topMargin + this.bottomMargin}>
        </svg>
        <Dimmer active={this.props.loading} inverted>
          <Loader />
        </Dimmer>
      </div>
    )
  }
}

export default LadderChart;
